import React from "react";
import { useNavigate } from "react-router-dom";
import { MODES, saveMode } from "./chatConfig";

export default function ChatLanding() {
  const nav = useNavigate();

  const pick = (key: string) => {
    const mode = MODES.find((m) => m.key === key);
    if (!mode) return;
    saveMode(mode);
    nav("/chat/play");
  };

  return (
    <div style={{ maxWidth: 980, margin: "0 auto", padding: "32px 16px" }}>
      <h1 style={{ fontSize: 28, marginBottom: 8 }}>Chat met Bella</h1>
      <p style={{ opacity: 0.75, marginBottom: 22 }}>
        Kies hoe je Bella wil gebruiken. Je kunt dit later bovenin altijd wisselen.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14 }}>
        {MODES.map((m) => (
          <button
            key={m.key}
            onClick={() => pick(m.key)}
            style={{
              textAlign: "left",
              borderRadius: 16,
              padding: 16,
              border: "1px solid rgba(20,20,40,0.12)",
              background: "rgba(255,255,255,0.65)",
              cursor: "pointer",
              boxShadow: "0 10px 30px rgba(20,20,40,0.08)",
            }}
          >
            <div style={{ fontWeight: 700, marginBottom: 6 }}>{m.label}</div>
            <div style={{ opacity: 0.75, fontSize: 14, lineHeight: 1.35 }}>{m.description}</div>

            {m.key.startsWith("openai") ? (
              <div style={{ marginTop: 12, fontSize: 12, opacity: 0.65 }}>
                Aanbevolen voor online demo
              </div>
            ) : (
              <div style={{ marginTop: 12, fontSize: 12, opacity: 0.65 }}>
                Tester modus (tunnel nodig)
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
